import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import {
	Collapse,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@material-ui/core";
import classNames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import boxScoreStyles from "../styles/BoxScore.styles";
import TeamLogo from "../../team/components/TeamLogo";
import driveSummaryStyles from "../styles/DriveSummary.styles";

const DriveRow = ({
	period,
	summary,
	playMessages,
	awayScore,
	homeScore,
	homeTeamHasPossession,
	scoreChanged,
	index,
	boxScore,
	expanded
}) => {
	const classes = driveSummaryStyles();
	const boxScoreClasses = boxScoreStyles();
	const [open, setOpen] = useState(expanded);
	const { homeTeam, awayTeam } = boxScore;

	return (
		<>
			<TableRow
				className={classNames(boxScoreClasses.row, classes.row)}
				key={`${index}`}
				onClick={() => setOpen(!open)}
			>
				<TableCell
					align="center"
					className={classNames(
						classes.column,
						{ "x-small": true },
						boxScoreClasses.nonPrintable
					)}
				>
					<IconButton aria-label="expand row" size="small">
						{open ? <ExpandLess /> : <ExpandMore />}
					</IconButton>
				</TableCell>
				<TableCell align="center">{period}</TableCell>
				<TableCell align="center">
					<TeamLogo
						team={homeTeamHasPossession ? homeTeam : awayTeam}
						hideName
						teamNameAsDefault
					/>
				</TableCell>
				<TableCell>{summary}</TableCell>
				<TableCell
					align="center"
					className={classNames({ [boxScoreClasses.textBold]: scoreChanged })}
				>
					{awayScore}
				</TableCell>
				<TableCell
					align="center"
					className={classNames({ [boxScoreClasses.textBold]: scoreChanged })}
				>
					{homeScore}
				</TableCell>
			</TableRow>

			<TableRow key={`${index}-detail`}>
				<TableCell
					className={classNames(classes.cell, boxScoreClasses.nonPrintable)}
				/>
				<TableCell className={classes.cell} />
				<TableCell className={classes.cell} />
				<TableCell className={classes.cell}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<ol>
							{playMessages.map((ss) => (
								<li>{ss}</li>
							))}
						</ol>
					</Collapse>
				</TableCell>
				<TableCell className={classes.cell} />
				<TableCell className={classes.cell} />
			</TableRow>
		</>
	);
};

const DriveSummary = ({ boxScore = {}, expanded = false }) => {
	const classes = driveSummaryStyles();
	const boxScoreClasses = boxScoreStyles();

	const { driveSummary, homeTeam, awayTeam } = boxScore;

	return (
		<Paper variant="outlined">
			<TableContainer>
				<Table>
					<TableHead className={boxScoreClasses.header}>
						<TableRow>
							<TableCell align="center" className={classes.column} />
							<TableCell align="center" className={classes.column}>
								<Typography className={boxScoreClasses.textBold}>
									Drive Summary
								</Typography>
							</TableCell>
							<TableCell align="center" className={classes.column} />
						</TableRow>
					</TableHead>
					<TableBody />
				</Table>
			</TableContainer>
			<TableContainer>
				<Table>
					<TableHead className={boxScoreClasses.header}>
						<TableRow>
							<TableCell
								align="center"
								className={classNames(
									classes.column,
									{ "x-small": true },
									boxScoreClasses.nonPrintable
								)}
							/>
							<TableCell
								align="center"
								className={classNames(classes.column, { "x-small": true })}
							>
								QTR
							</TableCell>
							<TableCell
								align="center"
								className={classNames(classes.column, { small: true })}
							>
								Team
							</TableCell>
							<TableCell>Summary</TableCell>
							<TableCell
								align="center"
								className={classNames(classes.column, { medium: true })}
							>
								<TeamLogo team={awayTeam} hideName teamNameAsDefault />
							</TableCell>
							<TableCell
								align="center"
								className={classNames(classes.column, { medium: true })}
							>
								<TeamLogo team={homeTeam} hideName teamNameAsDefault />
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{driveSummary?.map((item, index) => (
							<DriveRow
								{...item}
								index={index}
								boxScore={boxScore}
								expanded={expanded}
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

export default DriveSummary;
